import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Redirect, Switch } from 'react-router-dom'
import AuthService from 'src/cms/constants/authService'
import * as auth from './redux/actions'

export function Logout() {
  const dispatch = useDispatch()
  const authService = new AuthService()

  useEffect(() => {
    dispatch(auth.actions.logout())
    document.location.reload()
  }, [dispatch])

  return (
    <Switch>
      <Redirect to='/' />
    </Switch>
  )
}
